/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLibraryPlus: {
  name: 'library-plus';
  data: string;
} = {
  name: 'library-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h1V4Zm0 3H5v12h12v-1H8a2 2 0 0 1-2-2V7Zm12 9H8V4h12v12h-2Zm-3-8a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V8Z" fill="currentColor"/></svg>`,
};
